module.exports = __webpack_public_path__ + "img/xhs.bc804912.png";